<div class="basket-container">
    <div class="div-container">
        <div class="page-title">Ihr Warenkorb
            <div class="icons">
                <i class="fa-solid fa-hashtag" (click)="enterBarcode = true"></i>
                <i class="fa-solid fa-house" (click)="fallback()"></i>
            </div>
        </div>
        <div class="products" #productsContainer>
            <div class="product-container" *ngFor="let orderItem of orderItems; let i = index">
                <div class="product" (click)="selectedIndex = i"
                    [ngClass]="{'selected': selectedIndex == i}">
                    <div class="details">
                        <div class="name">{{orderItem.article.description}}
                        </div>
                        <div class="sub-details">{{orderItem.quantity + ' x CHF '+
                            (orderItem.article.baseUnitPrice |
                            number:'1.2-2')}}
                        </div>
                    </div>
                    <div class="chf">
                        <div>CHF</div>
                        <div class="discount-title" [ngClass]="{'loading':loading}">{{orderItem.article.discountedPrice !==
                            orderItem.article.baseUnitPrice * orderItem.quantity ? ((orderItem.article.baseUnitPrice *
                            0.88) > orderItem.article.singleDiscountedPrice ) ? 'Rabatte' : 'MA-Rabatt 11%' : ''}}</div>
                    </div>
                    <div class="price">
                        <div>{{(orderItem.article.baseUnitPrice * orderItem.quantity)| number:'1.2-2'}}</div>
                        <div class="discount-amount" [ngClass]="{'loading':loading}">{{orderItem.article.discountedPrice !==
                            orderItem.article.baseUnitPrice * orderItem.quantity ? (orderItem.article.discountedPrice -
                            (orderItem.article.baseUnitPrice * orderItem.quantity) | number:'1.2-2') : ''}}</div>
                    </div>
                    <div class="edits" *ngIf="selectedIndex == i">
                        <ng-container *ngIf=" orderItem.productType !== productTypeEnum.quantityProduct">
                            <i class="fa-solid fa-circle-minus"
                                (click)="correction(i,orderItem.quantity-1)"></i>
                            <div>{{orderItem.quantity}}</div><i class="fa-solid fa-circle-plus"
                                (click)="correction(i, orderItem.quantity+1)"></i>
                        </ng-container>
                        <i class="fa-solid fa-circle-xmark" *ngIf="orderItem.productType == productTypeEnum.quantityProduct"
                            (click)="correction(i,orderItem.quantity-orderItem.quantity)"></i>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="categories">
        <div class="categories-title">Artikel ohne Strichcode</div>
        <div class="categories-options">
            <div class="option" *ngFor="let category of categories" [routerLink]="['/category/'+ category.id]">
                <i class="category-icon fa-solid" [ngClass]="category.icon"></i>
                <div class="name">{{category.name}}</div>
            </div>
        </div>
    </div>
    <div #modal class="modal" *ngIf="enterBarcode">
        <div class="modal-body">
            <div class="modal-content">
                <div class="close" (click)="stopBarcode()"><i class="fa-solid fa-circle-xmark"></i>schliessen
                </div>
                <div class="keypad-container" *ngIf="!entredProduct">
                    <input type="text" readonly [ngModel]="scannedCode" [ngStyle]="{'font-size': scannedCode.length > 13 ?
                        '22px' : '40px'}">
                    <div class="error" *ngIf="errorScanned">Produkt nicht gefunden</div>
                    <div class="keypad">
                        @for (key of keypad; track $index) {
                        <div class="key" (click)="pressedKey(key)">{{key}}</div>
                        }
                    </div>
                </div>
                <div class="selection-details" *ngIf="entredProduct">
                    <img src="/assets/images/defaultProduct.svg">
                    <div class="sub-details">{{entredProduct.article.description}}</div>
                    <div class="edits"><i class="fa-solid fa-circle-minus" *ngIf="entredProduct.productType !== productTypeEnum.quantityProduct"
                            (click)="entredProduct.quantity = entredProduct.quantity > 1 ? entredProduct.quantity - 1 : 1"></i>
                        <div class="center-text">{{entredProduct.quantity + ' x CHF ' + (entredProduct.article.discountedPrice ?
                            (entredProduct.article.discountedPrice | number:'1.2-2')
                            : entredProduct.article.baseUnitPrice | number:'1.2-2')}}</div><i
                            class="fa-solid fa-circle-plus" *ngIf="entredProduct.productType !== productTypeEnum.quantityProduct"
                            (click)="entredProduct.quantity = entredProduct.quantity + 1"></i>
                    </div>
                    <p class="subtle-button" (click)="entredProduct = null">Falsches Produkt</p>
                </div>
            </div>
            <div class="submit" (click)="searchProduct()" *ngIf="!entredProduct"><i
                    class="fa-solid fa-magnifying-glass"></i>Nach Artikel suchen
            </div>
            <div class="submit" (click)="toBasket()" *ngIf="entredProduct"><i
                    class="fa-solid fa-circle-check"></i>In den Warenkorb
            </div>
        </div>
    </div>
</div>